import { Injectable } from '@angular/core';
import { Paginator } from '@app/classes';
import { AsyncSystemTask } from '@app/models/common/async-system-tasks.model';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { NameColumn, StatusColumn, StartedAtColumn, CompletedAtColumn, FailedAtColumn } from './columns';

@Injectable()
export class AsyncSystemTasksIndexTable extends Table {
    static viewOption = { label: 'View', event: 'view' };
    static deleteOption = { label: 'Delete', event: 'delete' };

    constructor() {
        super();
        this.boot();
    }

    showMenuColumnOptions = true;

    getMenuColumnOptionsForRow(asyncSystemTask: AsyncSystemTask): MenuColumnItem[] {
        if (!asyncSystemTask.isFinished()) {
            return [];
        }

        return [AsyncSystemTasksIndexTable.viewOption, AsyncSystemTasksIndexTable.deleteOption];
    }
    setColumns(): void {
        this.columns = [
            new NameColumn(),
            new StatusColumn(),
            new StartedAtColumn(),
            new CompletedAtColumn(),
            new FailedAtColumn(),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(AsyncSystemTask.query());
    }
}
